



















import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import router from '../../router/index';
import { UserInfo } from '../../types/type';
import { PAGE_PATH_BY_NAME } from '@/utils/consts';

@Component
export default class PortalUserInfoPanel extends Vue {
  @Prop()
  private userInfo!: UserInfo;

  @Prop({ type: Boolean, default: false })
  private flat!: boolean;

  @Prop({ type: Boolean, default: false })
  private small!: boolean;

  private openSetting() {
    router.push(PAGE_PATH_BY_NAME.setting);
  }
}
